// extracted by mini-css-extract-plugin
export default {"checkbox":"selectionCard_checkbox__cS61u","input":"selectionCard_input__kg6RV"};